const getIcon = require.context('!raw-loader!./icons', false, /\.svg$/);

export default angular
  .module('cian.addForm.icon', [])
  .directive('cianAfIcon', ['$compile', $compile => ({
    scope: {
      name: '@'
    },
    link(scope, element) {
      const iconWrapper = document.createElement('div');
      iconWrapper.innerHTML = getIcon(`./${scope.name}.svg`);

      const icon = iconWrapper.querySelector('svg');
      icon.setAttribute('class', `cui-icon cui-icon_${scope.name}`);

      element.html(icon.outerHTML);

      $compile(element.contents())(scope);
    },
  })])
  .name;
